import type { IFileUploaderValue } from './FileUploader';

export const areFileValuesEqual = (
  fileA: IFileUploaderValue,
  fileB: IFileUploaderValue,
): boolean => fileA.type === fileB.type && fileA.id === fileB.id;
